interface Option {
  text: string;
  value: number;
}

export function createDropdownOptions(length: number): Option[] {
  return [...Array(length).keys()].map(i => ({ text: (i + 1).toString(), value: i + 1 }));
}
